import React from 'react';

import { costCalculation as CostCalculation } from 'ui/views/widgets/costCalculation';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { costCalculationPreloader as CostCalculationPreloader } from 'ui/views/widgets/costCalculation';
import { get, map, isNil, toNumber, isNaN, isEmpty, noop } from 'lodash';
import { getLabel } from 'utils/getLabel';
import { radioBox as RadioBox } from 'ui/views/generic/radioBox';
import { getDisplayValue } from 'resolvers/formatValue';
import classnames from 'classnames';
import { Icon } from 'modules/icon-bank';

const resolvePaymentValue = ( value ) => {
    if( isNil( value ) || '' === value ) {
        return 0;
    }

    if( isNaN( toNumber( value ) ) ) {
        return 0;
    }

    if( ! isNaN( toNumber( value ) ) ) {
        return toNumber( value );
    }
    return value;
};

/************************************************* */

// @TODO: update the check for remianing balance,
// if it is negative, show a different error
const CostSelectionError = ( props ) => {

    const { isRemaningBalanceValid, balancePaymentField, remainingAmount } = props;

    if( isRemaningBalanceValid ) {
        return null;
    }

    const errorMessage = 0 > remainingAmount ? get( balancePaymentField.errorMessage, 'reminingBalanceCannotBeNegative', {} ): get( balancePaymentField.errorMessage, 'cannotExceedMaxRemainigAmountCap', {} );
    
    // const errorMessage = ! isPayOtherValueValid? get( balancePaymentField.errorMessage, 'cannotExceedBalancePayment', {} ): get( balancePaymentField.errorMessage, 'cannotExceedMaxRemainigAmountCap', {} );

    return(
        <div className='ui-balance-payment-error'>
            <Icon id={ 'flagError' } />
            <span>{ getLabel( errorMessage ) } </span>
        </div>
    );
};

/************************************************* */

const _memberCheckoutCostInformation = ( props ) => {

    const { costCalculationConfig, costCalculation, costSelection = {}, isRemaningBalanceValid,
        costSelectionConfig, chargeNowAmount, remainingAmount } = props;
    
    // order payment field
    const orderPaymentField = get( costSelectionConfig, 'orderPayment', {} );

    // balance payment field
    const balancePaymentField = get( costSelectionConfig, 'balancePayment', {} );

    // pay other value
    const selectedOrderPayment = get( costSelection.orderPayment, 'payLater.selected', false ) ? 'payLater': 'payTotal';

    // pay other value
    const selectedBalancePayment = get( costSelection.balancePayment, 'payTotal.selected', false ) ? 'payTotal': 'payOther';

    // total charge amount
    const selectedBalanceAmount = resolvePaymentValue( get( costSelection.balancePayment, `${selectedBalancePayment}.value`, 0 ) );
  
    // total payable amount
    const totalBalanceAmount = resolvePaymentValue( get( costSelection, 'balancePayment.payTotal.value', 0 ) );
    const totalOrderAmount = resolvePaymentValue( get( costSelection, 'orderPayment.payTotal.value', 0 ) );

    return (
        <div className='ui-member-checkout-cost-information'>

            {/* cost calculation widget */}
            <CostCalculation
                fields={ costCalculationConfig }
                values= { costCalculation }
                className={ 'ui-member-checkout-cost-information__cost' }
                flags={ get( props, 'flags', {} ) }
            />

            {/* order amount summary */}

            { ! isEmpty( costSelection ) && (
                <div className='ui-member-checkout-cost-information__payment'>

                    <div className='ui-member-checkout-cost-information__payment__values'>

                        {/* order paymentorderPayment */}
                        <div className='ui-member-checkout-cost-information__payment__values__order'>
                            <div className='ui-member-checkout-cost-information__payment__values__order__details'>
                                <div className='ui-member-checkout-cost-information__payment__values__order__details__title'>{ getLabel( orderPaymentField.title ) }</div>

                                { map( orderPaymentField.options, option => {
                                    return (
                                        <div key={ option.name } className='ui-member-checkout-cost-information__payment__values__order__details__option'
                                            onClick={ () => props.updateCostSelection( { type: 'orderPayment', item: option } ) }>

                                            <RadioBox name={ option.name } selected={ costSelection.orderPayment[ `${option.name}` ].selected } />
                                            { getLabel( option.title ) }

                                            { 'payTotal' === option.name && (
                                                <span className='ui-member-checkout-cost-information__payment__values__order__details__option__cost'>
                                                    { getDisplayValue( { type: 'currency', value: get( costSelection, 'orderPayment.payTotal.value', 0 ) } ) }
                                                </span>
                                            ) }

                                        </div>
                                    );
                                } ) }
                            </div>

                                {/* selected order payment total */}
                            <div className='ui-member-checkout-cost-information__payment__values__order__value'>
                                { getDisplayValue( { type: 'currency', value: get( costSelection, `orderPayment.${selectedOrderPayment}.value`, 0 ) } ) }
                            </div>
                        </div>

                        {/* balance payment */}
                        <div className='ui-member-checkout-cost-information__payment__values__order ui-member-checkout-cost-information__payment__values__order__balance-payment'>
                            <div className='ui-member-checkout-cost-information__payment__values__order__details'>
                                <div className='ui-member-checkout-cost-information__payment__values__order__details__title'>{ getLabel( balancePaymentField.title ) }</div>

                                { map( balancePaymentField.options, option => {

                                    // check if user can enter values
                                    const isPayOtherActive = get( costSelection, 'balancePayment.payOther.selected', false );

                                    // get input class name
                                    const inputClassName = classnames( 'ui-member-checkout-cost-information__payment__values__order__details__option__input', {
                                        'ui-member-checkout-cost-information__payment__values__order__details__option__input--disabled': ! isPayOtherActive,

                                        // 'ui-member-checkout-cost-information__payment__values__order__details__option__input--error': ! isPayOtherValueValid
                                    } );

                                    const payTotalBalance = resolvePaymentValue( get( costSelection, 'balancePayment.payTotal.value', 0 ) );

                                    // get class name
                                    const className = classnames( `ui-member-checkout-cost-information__payment__values__order__details__option ui-member-checkout-cost-information__payment__values__order__details__option__${option.name}`, {
                                        'ui-member-checkout-cost-information__payment__values__order__details__option--disabled': ( 0 === ( totalBalanceAmount + totalOrderAmount ) || ( 'payTotal' === option.name && 0 === payTotalBalance ) )
                                    } );

                                    const displayValue = getDisplayValue( { type: 'currency', value: get( costSelection, 'balancePayment.payTotal.value', 0 ) } );
                                    const payOtherValue = get( costSelection, 'balancePayment.payOther.value', 0 );


                                    return (
                                        <div key={ option.name } className={ className }
                                            onClick={ () => {

                                                if( 'payTotal' === option.name && 0 === payTotalBalance ) {

                                                        noop;

                                                    } else {

                                                    props.updateCostSelection( { type: 'balancePayment', item: option } );
                                                }
                                            } }
                                        >
                                            <RadioBox name={ option.name } readOnly={ 'payTotal' === option.name && 0 === payTotalBalance } selected={ costSelection.balancePayment[ `${option.name}` ].selected } />

                                            { getLabel( option.title ) }
                                            { 'payTotal' === option.name ? (

                                                <span className='ui-member-checkout-cost-information__payment__values__order__details__option__cost'>
                                                    { displayValue }
                                                </span>

                                            ) : (

                                                <div className={ inputClassName } onClick={ ( event ) => {
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                }}>
                                                    <span className='ui-member-checkout-cost-information__payment__values__order__details__option__input__dollar'>$</span>
                                                    <input name={ 'payother' } readOnly={ ! isPayOtherActive }
                                                        value={ ! isNil( payOtherValue ) ? payOtherValue: 0 }
                                                        type={ 'number' }
                                                        onChange={ ( event ) => props.onPayOtherAmountUpdate( event.target.value ) }
                                                    />
                                                </div>
                                            ) }

                                        </div>
                                    );
                                } ) }
                            </div>

                                {/* selected balance payment total */}
                            <div className='ui-member-checkout-cost-information__payment__values__order__value'>
                                { getDisplayValue( { type: 'currency', value: selectedBalanceAmount } ) }
                            </div>

                        </div>

                        {/* charge now */}
                        <div className='ui-member-checkout-cost-information__payment__values__total ui-member-checkout-cost-information__payment__values__total--marginbottom'>
                            <div className='ui-member-checkout-cost-information__payment__values__total__title'>{ getLabel( get( costSelectionConfig, 'chargeNow.title', {} ) ) }</div>
                            <div className='ui-member-checkout-cost-information__payment__values__total__value'>
                                { getDisplayValue( { type: 'currency', value: chargeNowAmount } ) }
                            </div>
                        </div>

                        <div className='ui-member-checkout-cost-information__payment__values__total'>
                            <div className='ui-member-checkout-cost-information__payment__values__total__title'>{ getLabel( get( costSelectionConfig, 'remainingBalance.title', {} ) ) }</div>
                            <div className='ui-member-checkout-cost-information__payment__values__total__value'>
                                { getDisplayValue( { type: 'currency', value: remainingAmount } ) }
                            </div>
                        </div>
                    </div>

                    <CostSelectionError
                        remainingAmount={ remainingAmount }
                        balancePayment={ get( costSelection, 'balancePayment', {} ) }
                        isRemaningBalanceValid={ isRemaningBalanceValid }
                        balancePaymentField={ balancePaymentField }
                    />
                    
                </div>
            ) }
           
        </div>
    );
};

// set display name
_memberCheckoutCostInformation.displayName = 'memberCheckoutCostInformation';

// set default props
_memberCheckoutCostInformation.defaultProps = {};

// prop types
_memberCheckoutCostInformation.propTypes = {};


const memberCheckoutCostInformationPreloader = () => {
    return(
        <div className='ui-member-checkout-cost-information-preloader'>
            <CostCalculationPreloader />

            <div className='ui-member-checkout-cost-information-preloader__section'>
                { map( [ ...Array( 2 ).keys() ], item => {
                    return (
                        <div key={ item } className='ui-member-checkout-cost-information-preloader__section__inline'>
                            <div className='ui-member-checkout-cost-information-preloader__section__inline__title'></div>
                            <div className='ui-member-checkout-cost-information-preloader__section__inline__selection'></div>
                            <div className='ui-member-checkout-cost-information-preloader__section__inline__selection'></div>
                            <div className='ui-member-checkout-cost-information-preloader__section__inline__value'></div>
                        </div>
                    );
                } ) }

                { map( [ ...Array( 2 ).keys() ], item => {
                    return (
                        <div key={ item } className='ui-member-checkout-cost-information-preloader__section__final'>
                            <div className='ui-member-checkout-cost-information-preloader__section__final__title'></div>
                            <div className='ui-member-checkout-cost-information-preloader__section__final__value'></div>
                        </div>
                    );
                } ) }
           </div>

        </div>
    );
};


// set display name
memberCheckoutCostInformationPreloader.displayName = 'memberCheckoutCostInformationPreloader';

// set default props
memberCheckoutCostInformationPreloader.defaultProps = {};

// prop types
memberCheckoutCostInformationPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberCheckoutCostInformation as MemberCheckoutCostInformation } from 'ui/views/widgets/memberCheckoutCostInformation';
 *
 * // render
 * <MemberCheckoutCostInformation propName='propValue'/>
 */
export const memberCheckoutCostInformation = withNetworkState( memberCheckoutCostInformationPreloader, _memberCheckoutCostInformation );

